import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SscApplicationService {
  constructor(private _http: HttpClient) {
  }

  findAllList(page: any) {
    return this._http.post<any>('api/a/gov-services/all', page);
  }

  getSscApplicationInfo(collegeId, applicationId) {
    return this._http.get<any>('api/a/gov-services/application/byId/' + collegeId + '/' + applicationId);
  }

  getServicesList() {
    return this._http.get<any>('api/a/gov-services/services/public');
  }

  getStatuses() {
    return this._http.get<any>('api/a/gov-services/statuses/all');
  }

  getStudentByIIN(collegeId, iin) {
    return this._http.get<any>('api/a/gov-services/student/iin/' + collegeId + '/' + iin);
  }

  applyGovServiceApplication(formData) {
    return this._http.post<any>(`api/a/gov-services/application/apply`, formData,
      {headers: {'noContentType': 'true'}});
  }

  getServiceDocs(serviceId: number) {
    return this._http.get<any>('api/a/gov-services/service/documents/' + serviceId);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/ssc.application.service.ts